import { Injectable } from '@angular/core';
import { CusHttp } from '../core/services/CusHttp';
import { URLSearchParams } from "@angular/http";
// 学生首次登录接口
const STUFIRSTLOGIN = 'v1/student/frist-complete';
// 首次登录完善信息 企业信息接口
const COMPANYFIRSTDATA = 'v1/company/frist-complete';

//获取企业资料设置已经存在的信息
const EXIST_DATASET = "v1/company/cmp-info";
//企业资料设置
const COM_DATASET = "v1/company/setting";
//企业修改密码
const MODIFY_PASS = "v1/users/updpwd";

//获取绑定账号已经存在的信息
const ACCOUNT_BIND = "v1/users/is-bind";
//解除绑定信息  解除绑定类型 1 微信 2 qq 3 微博’ 4:手机 5邮箱
const UNBOUND = "v1/users/relieve-bind?";

//发送验证码-绑定邮箱/手机(暂邮箱)
const SEND_CODE = "v1/users/send-code";
//立即绑定-----获取验证码(暂邮箱)
const VERIFY_CODE = "v1/users/check-code";

//获取企业资质认证已经存在的信息
const COM_STATUS = "v1/company/cmp-authentication";
//企业上传资质
const AUTHENTICATION = "v1/company/authentication";

//忘记密码
const FORGETCODE_URL = "forgetCode";
//忘记密码 验证码效验
const REFORGETCODE_URL = "validate";
//设置密码
const SETFORGETCODE_URL = "retrieve";

import { BACKEND_API_URL } from '../core/services/CusHttp';
import { Params } from '@angular/router';



@Injectable()
export class UserInfoService {

  constructor(
    public _http: CusHttp,
  ) { }
  //首次登录完善信息 学生信息接口
  postStuFirstLoginData(obj: any) {
    // let params = new URLSearchParams();
    // for (let option in obj) {
    //   if (typeof obj[option] != 'object') {
    //     params.append(option, obj[option])
    //   } else if (typeof obj[option] === 'object' && !!obj[option].length) {
    //     for (let i = 0; i < obj[option].length; i++) {
    //       params.append(option + '[' + i + '][position_hope_id]', obj[option][i]['position_hope_id']);
    //       params.append(option + '[' + i + '][position_hope_pid]', obj[option][i]['position_hope_pid']);
    //       params.append(option + '[' + i + '][position_hope_topid]', obj[option][i]['position_hope_topid']);
    //     }
    //   }
    // }
    let url = STUFIRSTLOGIN;
    return this._http.post(url, obj);
  }
  // 首次登录完善信息 企业信息接口
  postCompanyFirstData(obj: any) {
    let params = new URLSearchParams();
    for (let option in obj) {
      params.append(option, obj[option]);
    }
    let url = COMPANYFIRSTDATA;
    return this._http.post(url, params);
  }


  //获取企业资料设置已经存在的信息
  getExistDataset() {
    return this._http.get(`${EXIST_DATASET}`);
  }

  //企业资料设置
  comDataSet(formValue: any) {
    let params = new FormData();
    for (let i in formValue) {
      params.append(i, formValue[i]);
    }
    return this._http.post(`${COM_DATASET}`, params);
  }

  //企业修改密码
  modifyPass(formValue: any) {
    let params = new FormData();
    for (let i in formValue) {
      params.append(i, formValue[i]);
    }

    return this._http.post(`${MODIFY_PASS}`, params);

  }

  //获取绑定账号已经存在的信息
  getBindInfo() {
    return this._http.get(`${ACCOUNT_BIND}`);
  }

  //解除绑定信息  解除绑定类型 1 微信 2 qq 3 微博’ 4:手机 5邮箱
  getUnbound(type: any) {
    let params = new URLSearchParams();
    params.append('type', type);
    return this._http.get(`${UNBOUND}` + params.toString());
  }

  //发送验证码-绑定邮箱/手机(暂邮箱)
  sendCode(account: any) {
    let params = new FormData();
    params.append('account', account);
    return this._http.post(`${SEND_CODE}`, params);
  }
  //获取验证码(暂邮箱)   用户名    sessionid(发送验证码接口返回参数)  手机/邮箱
  getVerifyCode(code: any, sId: any, account: any) {
    let params = new FormData();
    params.append('code', code);
    params.append('sId', sId);
    params.append('account', account);
    return this._http.post(`${VERIFY_CODE}`, params);
  }

  //获取企业资质认证已经存在的信息
  getComStatus() {
    return this._http.get(`${COM_STATUS}`);
  }

  //企业上传资质
  getAuthentication(url: any) {
    let params = new FormData();
    params.append('url', url);
    return this._http.post(AUTHENTICATION, params);
  }

  //忘记密码
  // const FORGETCODE_URL = "forgetCode";
  getRegCode(user: string) {
    let url = FORGETCODE_URL + `?username=${user}`;
    return this._http.get(url);
  }
  //忘记密码 验证码效验
  // const REFORGETCODE_URL = "validate";
  postReForgetCode(code: string, sId: string) {
    let params = new FormData();
    params.append('code', code);
    params.append('sId', sId);
    return this._http.post(REFORGETCODE_URL, params);
  }
  //设置密码
  // const SETFORGETCODE_URL = "AAAAAAAAAAAAAAAA";
  postSetPassword(password: string, repassword: string, sId: string) {
    let params = new FormData();
    params.append('password', password);
    params.append('repassword', repassword);
    params.append('sId', sId);
    return this._http.post(SETFORGETCODE_URL, params);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/user-info.service.ts